import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=0d613cba"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d613cba')) {
      api.createRecord('0d613cba', component.options)
    } else {
      api.reload('0d613cba', component.options)
    }
    module.hot.accept("./Settings.vue?vue&type=template&id=0d613cba", function () {
      api.rerender('0d613cba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/auth/views/Settings.vue"
export default component.exports